<template>
  <div class="user-management-container">
    <vab-query-form>
      <vab-query-form-right-panel :span="24">
        <el-form :inline="true" :model="queryForm" @submit.prevent>
          <el-form-item label="">
            <el-select
              filterable
              v-model="queryForm.orderTypehood"
              placeholder="订单类型"
              clearable
            >
              <el-option
                v-for="item in typehoods"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model.trim="queryForm.keyword"
              clearable
              placeholder="订单号/备注"
            />
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              v-model="queryForm.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="YYYY-MM-DD"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="queryData">
              查询
            </el-button>
          </el-form-item>
        </el-form>
      </vab-query-form-right-panel>
    </vab-query-form>
    <el-table v-loading="listLoading" stripe :data="list">
      <el-table-column align="left" label="序号" width="55">
        <template #default="{ $index }">
          {{ $index + 1 }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="收款金额"
        prop="amount"
        show-overflow-tooltip
        width="150"
      />
      <el-table-column
        align="left"
        label="订单号"
        prop="basic.orderNo"
        show-overflow-tooltip
        width="150"
      />
      <el-table-column
        align="left"
        label="标题"
        prop="basic.text"
        show-overflow-tooltip
      />
      <el-table-column align="left" label="订单类型" show-overflow-tooltip width="150">
        <template #default="{ row }">
          {{ typehoods.find((e) => e.value == row.basic.orderTypehood)&&typehoods.find((e) => e.value == row.basic.orderTypehood).label }}
        </template>
      </el-table-column>
      <el-table-column
        align="left"
        label="创建时间"
        prop="created"
        show-overflow-tooltip
        width="200"
      >
        <template #default="{ row }">
          {{ moment(row.created).format('YYYY-MM-DD HH:mm:ss') }}
        </template>
      </el-table-column>
      <!-- <el-table-column
        align="left"
        fixed="right"
        label="操作"
        show-overflow-tooltip
        width="80px"
      >
        <template #default="{ row }">
          <el-button type="text" @click="handleShow(row)">详情</el-button>
        </template>
      </el-table-column> -->
      <template #empty>
        <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        />
      </template>
    </el-table>
    <el-pagination
      background
      :current-page="queryForm.page"
      :layout="layout"
      :page-size="queryForm.size"
      :total="total"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
    <!-- <ProductDetail ref="product" @fetch-data="fetchData" /> -->
  </div>
</template>

<script>
import moment from 'moment'
import { findRecordList } from '@/api/finance'
import {
  orderTypehoods,
  orderChannels,
  orderChannelOptions,
  orderSteps,
  orderTypehood,
} from '@/utils/const'
// import ProductDetail from '../products/detail.vue'
export default {
  name: 'Income',
  // components: { ProductDetail },
  data() {
    return {
      moment,
      typehoods: orderTypehoods,
      channels: orderChannelOptions,
      options: orderSteps,
      list: [],
      listLoading: true,
      layout: 'total, sizes, prev, pager, next, jumper',
      total: 0,
      selectRows: '',
      queryForm: {
        page: 1,
        size: 10,
        title: 'ONLINE',
        keyword: '',
        orderTypehood: '',
        date: null,
      },
    }
  },
  watch: {
    $route(to, from) {
      if (to.path == '/finance/income') {
        this.fetchData()
      }
    },
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleShow(row) {
      const key = orderTypehoods.find((e) => e.value == row.typehood).key
      this.$refs[`${key}`].show(row)
    },
    // 格式化订单支付方式
    formatChannel(row) {
      const channel = (row && row.payment && row.payment.channel) || 'UNKOWN'
      return orderChannels[channel]
    },
    handleSizeChange(val) {
      this.queryForm.size = val
      this.fetchData()
    },
    handleCurrentChange(val) {
      this.queryForm.page = val
      this.fetchData()
    },
    queryData() {
      this.queryForm.page = 1
      this.fetchData()
    },
    async fetchData() {
      this.listLoading = true
      const params = Object.assign({},this.queryForm)
      if(params.date!=null) {
        params.startDate = params.date[0]
        params.endDate = params.date[1]
      }
      delete params.date
      const { list, total } = await findRecordList(params)
      this.list = list
      this.total = total
      this.listLoading = false
    },
  },
}
</script>

<style lang="scss" scoped>
.diy-dropdown-menu {
  padding: 8px !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
}
.el-button {
  margin-left: 0px !important;
  margin-bottom: 6px;
}
.vab-query-form {
  :deep() {
    .el-form-item + .el-form-item {
      margin: 0 0 10px 10px !important;

      .el-button {
        margin: 0 0 0 0 !important;
      }
    }
  }
}
.avatar {
  height: 64px;
  width: 128px;
  border-radius: 8px;
}
</style>
